import { Badge, Card, Group, Image, Rating, Skeleton, Text } from '@mantine/core';
import { useState } from "react";
import { FaRegEye } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function ItemCard({ index, clsName, item }) {
  const [isLoaded, setIsLoaded] = useState(false);

  const onLoaded = () => {
    setIsLoaded(true);
  };

  const formattedProductName = (productName) => {
    return productName.replace(/[^\w\s]/gi, "").replace(/\s+/g, "-");
  };

  return (
    <>
      {item && (
        <div key={index} className={`${clsName} p-2 text-decoration-none`}>
          <Link
            to={`/products/${item.id}/${formattedProductName(item.name)}`}
            className="text-decoration-none"
          >
            <Card shadow="sm" padding="lg" radius="md" withBorder h="100%">
              <Card.Section>
                {!isLoaded && (
                  <Skeleton height={200} radius="md" />
                )}
                <Image
                  src={`${item.images && item.images.length > 0 && Object.values(item.images[0])[0]}`}
                  height={200}
                  alt={item.name}
                  onLoad={onLoaded}
                  style={{ display: isLoaded ? 'block' : 'none', objectFit: 'cover' }}
                />
              </Card.Section>

              <Group justify="space-between" mt="xs" wrap="nowrap">
                <Text fw={600} size="lg" lineClamp={1}>
                  {item.name}
                </Text>
                <Group gap={4} wrap="nowrap">
                  <Text size="sm" c="dimmed">
                    {item.views}
                  </Text>
                  <FaRegEye size={16} />
                </Group>
              </Group>

              {/* <ReactRating rate={item.condition} /> */}
              <Rating value={item.condition} readOnly />

              <Text size="sm" c="dimmed" mt="xs">
                {item.date_of_purchase}
              </Text>

              <Group justify="space-between" mt="sm">
                <Text fw={700} size="lg" c="black">
                  Rs. {item.price}
                </Text>
                <Badge color="pink" variant="light" size="sm">
                  Details &gt;
                </Badge>
              </Group>
            </Card>
          </Link>
        </div>
      )}
    </>
  );
}
